module.exports = __webpack_public_path__ + "media/images/admin/icons/instagram-4e7b4d585626bb3d0a5d43b3027ddc08.svg";